import { FC, MouseEvent, useCallback, useState } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { forRange } from 'components/_temp_ui_common/utilities/forRange';
import { preventDefault } from 'components/_temp_ui_common/utilities/preventDefault';
import { isEmailFormatted, useForm } from 'components/core/form';
import { AppLink } from 'components/core/link/Link';
import { theme } from 'components/core/theme';
import { Input } from 'components/form/Input';

import { RadioButton } from '../../components/raw-components/RadioButton';

export const ConsentAgreementBody: FC<{
  agreed: boolean | undefined;
  setAgreed: (v: boolean) => void;
}> = ({ agreed, setAgreed }) => {
  const [count, setCount] = useState(1);

  const { registerField } = useForm();

  const handleAddAnotherEmail = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      setCount(c => c + 1);
    },
    [],
  );

  return (
    <div className="agreement-accordion-body">
      <p>
        <Text variant="body-5">
          Is anyone else required to provide consent for behavioral health
          treatment due to legal custody?
        </Text>
      </p>
      <p className="flex">
        <RadioButton
          data-testid="no-additional-caregiver-consent-required"
          href="#link1"
          role="tablist"
          onClick={preventDefault(() => setAgreed(false), true)}
          style={{
            borderColor: '#d0d0d3',
            backgroundColor:
              agreed === false ? theme.colors.global.yellowMedium : '#fff',
            color: theme.colors.global.greyDark,
          }}
        >
          No
        </RadioButton>
        <RadioButton
          data-testid="yes-requires-additional-caregiver-consent"
          href="#link1"
          role="tablist"
          onClick={preventDefault(() => setAgreed(true), true)}
          style={{
            borderColor: '#d0d0d3',
            borderLeft: '1px solid #d0d0d3',
            backgroundColor: agreed ? theme.colors.global.yellowMedium : '#fff',
            color: theme.colors.global.greyDark,
          }}
        >
          Yes
        </RadioButton>
      </p>
      {agreed && (
        <p>
          <Text variant="body-5">
            Got it! Please provide the following details for all required
            parties. We will send a consent form that must be signed before care
            can begin.
          </Text>
        </p>
      )}
      {agreed &&
        forRange(0, count, idx => (
          <div
            className="consent-input-wrapper grid-12 m-grid-6"
            key={`input-group-${idx}`}
          >
            <div className="span-6">
              <Input
                name={`consentGivers[${idx}].firstName`}
                label="First Name"
              />
            </div>
            <div className="span-6">
              <Input
                name={`consentGivers[${idx}].lastName`}
                label="Last Name"
              />
            </div>
            <div className="span-12 m-span-6">
              <Input
                {...registerField(`consentGivers[${idx}].email`, {
                  validateOnBlur: true,
                  nullable: true,
                  validators: [isEmailFormatted],
                })}
                label="Email"
              />
            </div>
          </div>
        ))}
      {agreed && (
        <p className="add-another-link-wrapper">
          <AppLink to="" onClick={handleAddAnotherEmail}>
            <Text variant="body-5" bold>
              Add another email
            </Text>
          </AppLink>
        </p>
      )}
    </div>
  );
};
